import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Red_Outline_Btn.css";

const Red_Outline_Btn = (props) => {
  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ChefcutInvoice.pdf"); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  return (
    <button
      className="Red_Outline_Btn"
      type="button"
      onClick={
        props.onClick
          ? props.onClick
          : () => handleDownloadInvoice(props.order?.invoice)
      }
    >
      {props?.leftIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.leftIcon} className="left_icon" />
        </div>
      )}

      <p className="btn_text">{props?.btn_name}</p>

      {props?.rightIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.rightIcon} className="right_icon" />
        </div>
      )}
    </button>
  );
};

export default Red_Outline_Btn;
